import {
  buildCartFragment,
  updateShippingMessage,
  updateWholeSale,
  checkIfHeaderCartWasEmpty,
  getCart,
  postCartAdd,
} from '../utils/cart-tools';

import '../../../node_modules/flickity/css/flickity.css';
import '../../../node_modules/flickity-fade/flickity-fade.css';
import '../../styles/flickity-page-dots.scss';

import '../../styles/product.scss';
import '../../styles/product-swatches.scss';

import '../../styles/in-use.scss';

import '../sections/in-use';
import '../sections/pdp-video-block';

import Flickity from 'flickity-fade';

// Product Image Slider

const productSlider = document.querySelector('.product__images-container');

const flickity = new Flickity(productSlider, {
  autoplay: false,
  draggable: Modernizr.touchevents,
  fade: !Modernizr.touchevents,
  pageDots: true,
  prevNextButtons: false,
  watchCSS: true,
  wrapAround: true,
});

document
  .querySelector('.product__images-container')
  .addEventListener('click', (event) => {
    event.preventDefault();

    if (matchMedia('(min-width: 720px)').matches) {
      document.documentElement.classList.add('image-zoom-enabled');
      document.documentElement.scrollTop = 0;

      const productImageZoomeTemplateEl = document.querySelector(
        '#product__image-zoom-template',
      );
      const instance = document.importNode(
        productImageZoomeTemplateEl.content,
        true,
      );
      document.querySelector('#product__image-zoom__inner').append(instance);
    }
  });

document
  .querySelector('.product__image-zoom .close-button')
  .addEventListener('click', (event) => {
    document.documentElement.classList.remove('image-zoom-enabled');
    document.documentElement.scrollTop = 0;

    const parentEl = document.querySelector('#product__image-zoom__inner');

    while (parentEl.firstChild) {
      parentEl.firstChild.remove();
    }
  });

// Add To Bag
if (document.querySelector('.product-page-add-to-bag')) {
  document.querySelector('.add-to-cart-form').addEventListener('submit', e => {
    e.preventDefault();
    const { currentTarget } = e;
    const id = currentTarget.id.value;
    const quantity = currentTarget.quantity && currentTarget.quantity.value ? currentTarget.quantity.value : 1;
    const initialInnerText = currentTarget.querySelector('.product-page-add-to-bag').innerText;
    const cartCounts = document.querySelectorAll('.cart-count');
    let cartSubtotals = document.querySelectorAll('.cart-subtotal');

    postCartAdd({ id, quantity })
      .then(() => {
        currentTarget.querySelector('.product-page-add-to-bag').innerText = 'adding…'
        getCart()
          .then((resData) => {
            const bags = document.querySelectorAll('.cart-nav');

            currentTarget.querySelector('.product-page-add-to-bag').innerText = initialInnerText;
            cartCounts.forEach(el => el.innerHTML = resData.item_count);

            if (document.querySelector('.cart-items-scroll')) {
              document.querySelector('.cart-items-scroll').innerHTML = buildCartFragment({ resData });
            }

            checkIfHeaderCartWasEmpty({ resData });
            cartSubtotals = document.querySelectorAll('.cart-subtotal');
            [...cartSubtotals].forEach(el => el.innerHTML = `$${resData.total_price / 100}`);

            updateWholeSale({ resData });

            [...document.querySelectorAll('[ data-cart-shipping-message]')].forEach(shipping => {
              if (shipping) {
                shipping.innerHTML = updateShippingMessage({ resData });
              }
            });

            [...bags].forEach(bag => bag.classList.add('addingToCart'));
              setTimeout(() => {
                [...bags].forEach(bag => bag.classList.remove('addingToCart'));
              }, 1500);
            });
      });
  });
}

if (document.querySelector('.product__qty-wrapper')) {
  document
    .querySelector('.product__qty-wrapper')
    .addEventListener('click', (e) => {
      const { target } = e;

      if (target.classList.contains('product__qty')) {
        e.preventDefault();

        if (target.classList.contains('product__qty-minus')) {
          target.nextElementSibling.stepDown();
        } else {
          target.previousElementSibling.stepUp();
        }
      }
    });
}
